import { maskify, formatAsPhoneNumber } from 'utils';
import { SECURITY_CHANNEL_TYPES } from 'utils/constants';
import { SecuritySliceType } from './types';

export const initialSecurityState: SecuritySliceType = {
  isFetched: false,
  channels: {
    [SECURITY_CHANNEL_TYPES.sms]: '',
    [SECURITY_CHANNEL_TYPES.email]: '',
    [SECURITY_CHANNEL_TYPES.call]: '',
  },
};

export function maskPhoneNumber(phoneNumber: string) {
  return formatAsPhoneNumber(maskify(phoneNumber));
}

export function maskEmail(email: string) {
  const superator = '@';
  const splitArr = email.split(superator);
  splitArr[0] = splitArr[0].slice(-4).padStart(10, '•');
  return splitArr.join(superator);
}
